import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
export { configure } from './api';
export const routes = [{
  path: '/extreme-movers',
  component: <History />
}, {
  path: '/extreme-movers/settlement',
  component: <SettlementQueue />
}, {
  path: '/extreme-movers/create',
  component: <PredictionInput />
}, {
  path: '/extreme-movers/prompts',
  component: <PublicPrompt />
}, {
  path: '/extreme-movers/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/extreme-movers/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'extreme-movers',
  label: 'Extreme Movers',
  icon: 'ri-stock-line',
  link: '/extreme-movers'
};
export const publicNavigation = { label: 'Extreme Movers', link: '/extreme-movers', group: 'AI modes' };
export function getNavigation({ admin, paid }) {
  return { ...navigation, subItems: [
    {id:'extreme-movers-history',label:'History',link:'/extreme-movers',parentId:navigation.id},
    ...(admin ? [
      {id:'extreme-movers-input',label:'Prediction Input',link:'/extreme-movers/create',parentId:navigation.id},
      {id:'extreme-movers-settlement',label:'Settlement',link:'/extreme-movers/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
